import { ModalSizes, IDynamicResizing, IModalSizeProps, ModalSizeType } from './IModal';

export const getDefaultDimensions = (
  dynamicResizing: IDynamicResizing | boolean,
  sizeProp: string | IModalSizeProps,
) => {
  const size = typeof sizeProp === 'string' ? sizeProp : sizeProp?.default;
  const modalSize = size.toLocaleUpperCase();
  const sizes = Object.keys(ModalSizes);

  const maxWidth = Object.values(ModalSizes)[sizes.indexOf(modalSize)];
  const minWidth = Object.values(ModalSizes)[sizes.indexOf(modalSize) + 1];
  const margin = '6.25rem';
  const defaultDimensions = { maxWidth, minWidth, margin };

  if (typeof dynamicResizing === 'boolean' && dynamicResizing) {
    return defaultDimensions;
  }

  return Object.assign(defaultDimensions, dynamicResizing);
};

export const getModalSize = (size: IModalSizeProps | ModalSizeType) => {
  return size === 'sm' || size === 'lg' || size === 'xl'
    ? size
    : typeof size !== 'string' && size?.default && size?.default !== 'md'
    ? size.default
    : undefined;
};

export const getMobileSize = (size: IModalSizeProps | ModalSizeType) => {
  return typeof size !== 'string' && size?.mobileMode
    ? size?.mobileMode
    : size === 'lg' || size === 'xl'
    ? 'fs'
    : 'msx';
};
